module.exports = __webpack_public_path__ + "img/handcare_handgelmini_202312.3d8b64ed.jpg";